import { gql } from 'graphql-tag';

// Mutation to start user credits export job
export const EXPORT_USER_CREDITS = gql`
  mutation GetUserOpenCreditsByAccountReport($input: GetUserCreditsInput!) {
    getUserOpenCreditsByAccountReport(input: $input) {
      jobId
      message
    }
  }
`;

// Subscription to track export progress
export const USER_CREDITS_EXPORT_STATUS = gql`
  subscription UserCreditsExportStatus($jobId: String!) {
    userCreditsExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      filename
      recordCount
      error
    }
  }
`;

// Query to get download URL when export is complete
export const GET_USER_CREDITS_EXPORT_DOWNLOAD_URL = gql`
  query GetUserCreditsExportDownloadUrl($jobId: String!) {
    getUserCreditsExportDownloadUrl(jobId: $jobId)
  }
`;
